import { GREY_MID } from '@payaca/constants/colours';
import { getReadableTextColour } from '@payaca/utilities/colourUtilities';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC } from 'react';

const EPC_RATING_BADGE_COLOURS: Record<string, string> = {
  A: '#5AC487',
  B: '#54B263',
  C: '#9BCC5B',
  D: '#F8D748',
  E: '#F0AE71',
  F: '#E1863D',
  G: '#D63442',
};

export const EpcRatingBadge: FC<{
  rating: string | null | undefined;
  energyEfficiency?: number | null | undefined;
  size?: 'sm' | 'md';
}> = (props) => {
  const { rating, energyEfficiency, size = 'md' } = props;

  if (!rating) return null;
  const colour = EPC_RATING_BADGE_COLOURS[rating.toUpperCase()] ?? GREY_MID;
  const textColour = getReadableTextColour(colour);

  const isSmall = size === 'sm';
  const boxClassName = isSmall
    ? 'flex h-8 items-center justify-center px-2 text-sm font-bold'
    : 'flex h-12 w-12 items-center justify-center font-bold';
  const arrowClassName = isSmall ? 'w-4 shrink-0' : 'w-6 shrink-0';

  // The arrow tip is a clip-path triangle stretched to the box's height, so the
  // edges line up at any font size.
  return (
    <div className={clstx('flex items-stretch', !isSmall && 'mt-2')}>
      <div
        data-testid="epc-rating-badge"
        className={boxClassName}
        style={{
          backgroundColor: colour,
          color: textColour,
        }}
      >
        {energyEfficiency && <>{energyEfficiency} </>} {rating}
      </div>
      <div
        aria-hidden
        className={arrowClassName}
        style={{
          backgroundColor: colour,
          clipPath: 'polygon(0 0, 100% 50%, 0 100%)',
        }}
      />
    </div>
  );
};
